//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	//import { DropList } from '@/api'
	import { mapState } from 'vuex'
	export default{
		name:'st_sidebar',
		props:{
			animation_status:{
				type:Number,
				default:0
			}
		},
		data(){
			return{
				top:false,
				timer:null,
				Drop:[],//最近掉落
			}
		},
		created() {
			//this.getDropList()
			//this.settime()
			/*if (sessionStorage.getItem('sidebarTop')) {
				this.top = JSON.parse(sessionStorage.getItem('sidebarTop'))
			}*/
		},
		
		methods:{
			/*getDropList(){
				DropList(this.$route.query.id).then(res => {
					// console.log(res.data)
					this.Drop = res.data
				})
			},
			
			settime(){
				this.timer = setInterval(() => {
					this.getDropList()
				},5000)
			},*/
			
			
			
			to_warehouse(){
					this.$router.push('/official/warehouse')

			},
		},
		
		computed:{
			...mapState(['scrape'])
		},
		
		watch:{
			top(v){
				sessionStorage.setItem('sidebarTop', v)
			}
		},
		
		beforeDestroy() {
			// this.$log('退出')
			clearInterval(this.timer)
			this.timer = null
		},
	}
